const Partner = () => import(/* webpackChunkName: "partner" */ '@/views/private/partner/Index.vue')
const Account = () => import(/* webpackChunkName: "partneraccount" */ '@/components/partner/Account.vue')

const routes = [
  {
    path: "/partner",
    name: "partner",
    component: Partner,
    meta: {
      title: "Partnership"
    },
    children: [
      {
        path: '/partner/account',
        name: 'partner account',
        component: Account,
        meta: {
          title: "Pengaturan Akun Partnership"
        }
      }
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})